import { HMAnalytics } from '@happymoneyinc/analytics'
import { useEffect } from 'react'
import { loggerClient } from '../utils/loggerClient'

const trackEvent = (eventName, eventData) => {
  HMAnalytics.track(eventName, eventData)
  loggerClient.info(`[Analytics] event ${ eventName }`, {
    eventName,
    eventData
  })
}

const useAnalytics = (eventName, eventData) => {
  useEffect(() => {
    trackEvent(eventName, eventData)
  }, [])
}

export { trackEvent, useAnalytics }
